import { globalVars } from "Config";
import { load } from "@cashfreepayments/cashfree-js";
import { useEffect, useRef } from "react";

const CashFreePG = (props: { data: any; queryParams: any }) => {
  const { data } = props;
  const { paymentSessionId }: { paymentSessionId: string } = data.params;

  // Prevent double-invocation in React 18 StrictMode (dev)
  const hasInitiated = useRef(false);

  useEffect(() => {
    if (hasInitiated.current) return;
    hasInitiated.current = true;

    const initAndPay = async () => {
      try {
        const cashfree = await load({ mode: globalVars.APPLICATION_MODE === "production" ? "production" : "sandbox" });

        const checkoutOptions = {
          paymentSessionId,
          redirectTarget: "_self",
        };

        const result = await cashfree.checkout(checkoutOptions);

        if (result.error) {
          console.log("Payment error, check status:", result.error);
        }
        if (result.redirect) {
          console.log("Payment will be redirected");
        }
        if (result.paymentDetails) {
          console.log("Payment completed:", result.paymentDetails.paymentMessage);
        }
      } catch (err) {
        console.error("Cashfree init/checkout failed:", err);
      }
    };

    if (paymentSessionId) {
      initAndPay();
    } else {
      console.error("No paymentSessionId provided for Cashfree checkout");
    }
  }, [paymentSessionId]);

  return (
    <>
      <button type="submit" id="renderBtn" style={{ display: "none" }}>
        Pay Now
      </button>
    </>
  );
};

export default CashFreePG;